import Video from '~/components/Video';
import { VideoInterface } from '~/payload-types';

export type VideoBlockProps = VideoInterface & {};

const VideoBlock = (props: VideoBlockProps) => {
  if (typeof props.video === 'number') {
    throw new Error('Missing video');
  }

  return (
    <Video
      src={props.video.url!}
      controls={props.controls!}
      loop={props.loop!}
      autoPlay={props.autoPlay!}
      muted={props.muted!}
    ></Video>
  );
};

export default VideoBlock;
